export type ResetPasswordRouteSearch = {
  token?: string;
};

export function resetPasswordRouteSearchSchema(
  search: Record<string, unknown>,
): ResetPasswordRouteSearch {
  return typeof search['token'] === 'string' ? { token: search['token'] } : {};
}
